import React from "react";

const MainContext = React.createContext(
  {
    user: null,
    setUser: () => { },
    isLogging: null,
    checkout: null,
    loginDialog: null,
    setLoginDialog: () => { },
    notificationPermissions: null,
    setNotificationPermissions: () => { },
    notificationBanner: null,
    setNotificationBanner: () => { },
    notifications: null,
    setNotifications: () => { },
    unreadMessages: null,
    setUnreadMessages: () => { },
    whiteboard: null,
    setWhiteboard: () => {},
    error: null,
    setError: () => {},
    sidenav: null,
    setSidenav: () => {},
    fcmToken: null,
    setFcmToken: () => {},
    appVersion: null,
    setAppVersion: () => {},
  }
);

export default MainContext;
